import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import {
  flyout_headerVSpacing,
  flyout_innerBlockVSpacing,
  spacing,
} from 'ext-ui/style/spacing'
import { font_sm, fontH3, fontRegular } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${flyout_headerVSpacing};

  .title {
    ${fontH3}
  }

  .content {
    display: grid;
    grid-template-columns: 50% 50%;
    gap: ${flyout_innerBlockVSpacing} ${spacing(12)};

    .detail {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: ${spacing(1)};

      .detail-header {
        display: flex;
        flex-direction: row;
        gap: ${spacing(1)};
        align-items: center;
        ${font_sm}
        color: ${text_colorTextSecondary};
      }

      .detail-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;

        &:not(.link) {
          ${fontRegular}
          color: ${text_colorTextPrimary};
        }
      }
    }
  }
`
